import { clsx } from 'clsx'
import styles from './Ada.module.scss'
import AdaBannerWallpaper from '@/components/Advertising/Ada/AdaBannerWallpaper'

const AdaDefault = ({ name, position }: { name: string; position: number }) => {
  if (name === 'combi') {
    return <AdaBannerWallpaper />
  }

  return (
    <div className={clsx(styles.wrapper, styles[name], styles[name + '-' + position], name)}>
      <div className={'gujAd'} id={name + '_' + position}></div>
    </div>
  )
}

export default AdaDefault
